import { AnyAction } from "redux";
import { Update, FindById } from "../../../products";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Adapter } from "../../../../shared/adapter";
import { ProductAdapter } from "../../../../adapter/products-adapter";

export const FETCH_UPDATE_PRODUCT_REQUEST = "FETCH_UPDATE_PRODUCT_REQUEST";
export const FETCH_UPDATE_PRODUCT_SUCCESS = "FETCH_UPDATE_PRODUCT_SUCCESS";
export const FETCH_UPDATE_PRODUCT_FAILURE = "FETCH_UPDATE_PRODUCT_FAILURE";
export const SET_UPDATE_PRODUCT = "SET_UPDATE_PRODUCT";

interface ActionPagination<T> {
  type: string;
  payload: T;
}

const fetchUpdateProductRequest = () => {
  return {
    type: FETCH_UPDATE_PRODUCT_REQUEST,
  };
};

const fetchUpdateProductSuccess = (
  data: any
): ActionPagination<Result<any>> => {
  return {
    type: FETCH_UPDATE_PRODUCT_SUCCESS,
    payload: data,
  };
};

const fetchUpdateProductFailure = (error: any) => {
  return {
    type: FETCH_UPDATE_PRODUCT_FAILURE,
    payload: error,
  };
};

export const setUpdateProduct = (data: any) => {
  return {
    type: SET_UPDATE_PRODUCT,
    payload: data,
  };
};

export const update = (id: string, data: any) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(fetchUpdateProductRequest());
    try {
      const response = await Update(id, data);

      dispatch(
        fetchUpdateProductSuccess(
          Adapter.from(response.data).to((value) =>
            new ProductAdapter(value).adapt()
          )
        )
      );
    } catch (error: any) {
      dispatch(fetchUpdateProductFailure(error.message));
    }
  };
};

export const findById = (id: string) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(fetchUpdateProductRequest());
    try {
      const response = await FindById(id, "fields=*.*");
      dispatch(setUpdateProduct(response.data));
    } catch (error: any) {
      dispatch(fetchUpdateProductFailure(error.message));
    }
  };
};
